<template>
  <v-app>
    <AppBar
      color="primary"
      app-name="my-nsw-gov"
      :search-filter-mutator="false"
      :show-full-screen="false"
      :show-nav-icon="false"
    >
      <template slot="appIcon">
        <a :href="headerLink">
          <AppIcon
            app-name="my-nsw-gov"
            :transparent="true"
            size="50px"
            class="mt-2 ml-8"
          />
        </a>
      </template>
      <template slot="title">
        <v-toolbar-title class="pl-0">
          <a :href="headerLink">
            <span
              class="ml-0 pl-2 mr-5 mb-4 white--text"
              style="vertical-align: middle; line-height: 40px;"
            >
              <span style="font-weight: bold;">{{ headerTitle }}</span>
            </span>
          </a>
        </v-toolbar-title>
      </template>
    </AppBar>

    <v-content
      fluid
      style="height: 100%"
    >
      <v-container
        fluid
        style="margin-top: 2vh"
        class="d-flex align-center justify-center"
      >
        <v-row class="d-flex align-center justify-center">
          <v-col class="col-12 col-md-9 col-xl-6">
            <v-card class="pa-6 pt-10">
              <div class="d-flex justify-center">
                <svg
                  width="185"
                  height="185"
                  viewBox="0 0 185 185"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M92.5 185C143.586 185 185 143.586 185 92.5C185 41.4137 143.586 0 92.5 0C41.4137 0 0 41.4137 0 92.5C0 143.586 41.4137 185 92.5 185Z"
                    fill="#C8DCF0"
                  />
                  <path
                    d="M120.927 67.3072C120.069 67.2884 119.21 67.3263 118.356 67.4207C115.153 62.2423 110.554 58.0737 105.086 55.3948C99.6182 52.7159 93.5052 51.6357 87.4505 52.2785C81.3959 52.9214 75.646 55.2611 70.8627 59.0284C66.0795 62.7957 62.4575 67.8373 60.4138 73.5727C54.7428 73.7489 49.3678 76.1444 45.4453 80.2437C41.5228 84.343 39.3664 89.8184 39.4403 95.4916C39.5142 101.165 41.8123 106.582 45.8402 110.578C49.8681 114.574 55.3037 116.829 60.9773 116.857H71.4899C72.4986 116.857 73.466 116.456 74.1793 115.743C74.8926 115.03 75.2933 114.062 75.2933 113.054C75.2933 112.045 74.8926 111.077 74.1793 110.364C73.466 109.651 72.4986 109.25 71.4899 109.25H60.9752C57.3339 109.172 53.8681 107.67 51.3205 105.068C48.7729 102.465 47.3462 98.9674 47.3462 95.3252C47.3462 91.6831 48.7729 88.1858 51.3205 85.5829C53.8681 82.98 57.3339 81.4785 60.9752 81.4003C61.4209 81.4003 61.7573 81.5139 62.2073 81.5139L62.7665 81.6274C63.7106 81.7614 64.6706 81.537 65.4575 80.9984C66.2444 80.4598 66.801 79.6461 67.0178 78.7175C68.1744 73.8031 70.8193 69.3653 74.5916 66.0099C78.3638 62.6544 83.0796 60.5448 88.0954 59.9689C93.1111 59.3931 98.1823 60.379 102.617 62.7922C107.051 65.2054 110.633 68.9283 112.874 73.4527C113.264 74.2335 113.908 74.8584 114.701 75.2244C115.493 75.5905 116.387 75.676 117.234 75.4669C118.402 75.1602 119.605 75.0103 120.813 75.0212C123.06 75.0212 125.286 75.4639 127.362 76.324C129.439 77.1841 131.325 78.4448 132.915 80.0341C134.504 81.6234 135.765 83.5101 136.625 85.5866C137.485 87.6631 137.928 89.8886 137.928 92.1362C137.928 94.3838 137.485 96.6094 136.625 98.6859C135.765 100.762 134.504 102.649 132.915 104.238C131.325 105.828 129.439 107.088 127.362 107.948C125.286 108.809 123.06 109.251 120.813 109.251H113.429C112.42 109.251 111.452 109.652 110.739 110.365C110.026 111.079 109.625 112.046 109.625 113.055C109.625 114.063 110.026 115.031 110.739 115.744C111.452 116.457 112.42 116.858 113.429 116.858H120.813C127.336 116.8 133.573 114.173 138.171 109.545C142.768 104.917 145.356 98.6628 145.371 92.1393C145.386 85.6159 142.828 79.3497 138.251 74.7007C133.675 70.0517 127.45 67.395 120.927 67.3072V67.3072Z"
                    fill="#041E42"
                  />
                  <path
                    d="M104.04 105.357C103.321 104.657 102.358 104.265 101.355 104.265C100.352 104.265 99.3884 104.657 98.6699 105.357L92.5211 111.509L86.3692 105.357C85.6571 104.645 84.6913 104.245 83.6843 104.245C82.6772 104.245 81.7114 104.645 80.9993 105.357C80.2872 106.069 79.8872 107.035 79.8872 108.042C79.8872 109.049 80.2872 110.014 80.9993 110.727L87.147 116.883L80.9951 123.035C80.2953 123.753 79.9037 124.717 79.9037 125.72C79.9037 126.723 80.2953 127.686 80.9951 128.405C81.3408 128.765 81.757 129.05 82.2178 129.243C82.6787 129.435 83.1742 129.531 83.6735 129.523C84.1743 129.541 84.6731 129.451 85.1355 129.258C85.5979 129.065 86.0129 128.773 86.352 128.405L92.504 122.253L98.6559 128.405C99.0017 128.765 99.4179 129.05 99.8787 129.243C100.34 129.435 100.835 129.531 101.334 129.523C101.835 129.541 102.334 129.451 102.796 129.258C103.259 129.065 103.674 128.773 104.013 128.405C104.713 127.686 105.104 126.723 105.104 125.72C105.104 124.717 104.713 123.753 104.013 123.035L97.8781 116.883L104.03 110.731C104.733 110.015 105.128 109.051 105.13 108.048C105.132 107.044 104.74 106.079 104.039 105.361L104.04 105.357Z"
                    fill="#041E42"
                  />
                </svg>
              </div>
              <div class="d-flex justify-center title pt-8">
                {{ title }}
              </div>
              <v-row class="d-flex justify-center">
                <v-col class="col-12 col-md-8 px-12">
                  <p
                    class="body-1 pt-4"
                    style="text-align: center"
                    v-for="(t, i) in texts"
                    :key="i"
                    v-html="parseText(t)"
                  />
                </v-col>
              </v-row>
            </v-card>
            <v-row v-if="showStaffEssentials || showStudentEssentials">
              <v-col class="col-12">
                <v-row>
                  <v-col
                    v-if="showStaffEssentials"
                    class="col-12"
                    :class="{'col-md-6': showStudentEssentials }"
                  >
                    <v-card class="pa-6">
                      <div class="subtitle-1 ml-3">
                        Staff Essentials
                      </div>
                      <div class="pl-3">
                        <Essentials :essentials-data="staffEssentials" />
                      </div>
                    </v-card>
                  </v-col>
                  <v-col
                    v-if="showStudentEssentials"
                    class="col-12"
                    :class="{'col-md-6': showStaffEssentials }"
                  >
                    <v-card class="pa-6">
                      <div class="subtitle-1 ml-3">
                        Student Essentials
                      </div>
                      <div class="pl-3">
                        <Essentials :essentials-data="studentEssentials" />
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <div class="d-flex justify-center mt-3">
              <p
                class="body-1 pt-4"
                style="text-align: center"
                v-for="(t, i) in footer"
                :key="i"
                v-html="parseText(t)"
              />
              <!--<p>If you continue to see this page please contact our IT service desk EDConnect on 1300 32 32 32 or email <a :href="edConnectMailLink">EDConnect</a>.</p>-->
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import {AppBar, 
  // MyEssentials, 
  AppIcon
  } from "@nswdoe/doe-ui-core";
  import Essentials from "@/components/Essentials";

  const edConnectMailLink = () => {
    const now = new Date().toString();
    const subject = `Service Interruption: Portal on ${now}`;
    return `mailto:itinfraservmiddleware@det.nsw.edu.au;itweb-admin@det.nsw.edu.au?subject=${encodeURIComponent(subject)}`
  }

const defaultContent = {
  windowTitle: "Department of Education - Scheduled Maintenance",
  headerTitle: "NSW Department of Education",
  headerLink: "https://portal.det.nsw.edu.au/",
  title: "Scheduled maintenance",
  content: [
    "We are currently undertaking scheduled maintenance from",
    "<b>9:00pm to 10:00pm Tuesday 5 May, 2020</b>",
    "We apologise for the inconvenience and thank you for your patience.",
    "Time now: $dateTime"
  ],
  showStaffEssentials: true,
  showStudentEssentials: true,
  footer: [
    "If you continue to see this page please contact our IT service desk EDConnect on 1300 32 32 32 or email <a href=" +
      edConnectMailLink("Portal") +
      ">EDConnect</a>. "
  ]
};

  const getOverrideOrDefault = (propName, defaultValue) => {
    if (!window.doeOutagePageConfig || window.doeOutagePageConfig[propName] == null) {
      return defaultValue;
    }

    return window.doeOutagePageConfig[propName];
  };

  export default {
    name: "App",
    components: {
      AppBar,
      // MyEssentials,
      AppIcon,
      Essentials
    },
    created() {
      const windowTitle = getOverrideOrDefault('windowTitle');
      if (windowTitle) {
        document.title = windowTitle;
      }
    },
    data() {
      return {
        headerTitle: getOverrideOrDefault('headerTitle', defaultContent.headerTitle),
        headerLink: getOverrideOrDefault('headerLink', defaultContent.headerLink),
        title: getOverrideOrDefault('title', defaultContent.title),
        texts: getOverrideOrDefault('content', defaultContent.content),
        footer: getOverrideOrDefault('footer', defaultContent.footer),
        showStaffEssentials: getOverrideOrDefault('showStaffEssentials', false),
        showStudentEssentials: getOverrideOrDefault('showStudentEssentials', false),
        staffEssentials: window.staffEssentials || [],
        studentEssentials: window.studentEssentials || []
      }
    },
    methods: {
      parseText(text) {
        return text.replace(/\$dateTime/g, new Date().toString());
      }
    }
  };
</script>

<style lang="scss">
@import './scss/ads.scss';

  hr {
    border: none;
    border-top: 1px solid #DDD;
  }
</style>